/* GA4 Ecommerce — JTR custom pixel (theme asset)
   Tracks add_to_cart and view_item for GA4 property G-ZP3SHECT02
   via fetch/XHR interception. Injected via layout/theme.liquid.
   Added: 2026-06-10 */
(function () {
  'use strict';

  var GA4_ID = 'G-ZP3SHECT02';

  /* ---- helpers ---- */
  function currency() {
    return (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'CAD';
  }

  function waitGtag(fn, tries) {
    if (typeof window.gtag === 'function') { fn(); return; }
    if ((tries || 0) > 30) { return; }
    setTimeout(function () { waitGtag(fn, (tries || 0) + 1); }, 300);
  }

  function fireAddToCart(data) {
    waitGtag(function () {
      var raw = Array.isArray(data.items) ? data.items : (data.items ? [data] : [data]);
      var items = raw.map(function (item) {
        return {
          item_id:      String(item.product_id || item.id || ''),
          item_name:    item.product_title || item.title || '',
          item_variant: item.variant_title || '',
          price:        (item.final_price !== undefined ? item.final_price : (item.price || 0)) / 100,
          quantity:     item.quantity || 1
        };
      });
      var value = items.reduce(function (s, i) { return s + i.price * i.quantity; }, 0);
      window.gtag('event', 'add_to_cart', {
        currency: currency(),
        value:    Math.round(value * 100) / 100,
        items:    items
      });
    });
  }

  /* ---- intercept fetch ---- */
  var _fetch = window.fetch;
  window.fetch = function (resource, init) {
    var p = _fetch.apply(this, arguments);
    var url = (resource && resource.url) ? resource.url : String(resource || '');
    if (/\/cart\/add/.test(url)) {
      p.then(function (res) {
        var clone = res.clone();
        clone.json().then(fireAddToCart).catch(function () {});
        return res;
      }).catch(function () {});
    }
    return p;
  };

  /* ---- intercept XHR ---- */
  var _open = XMLHttpRequest.prototype.open;
  var _send = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (m, u) {
    this._jtrUrl = String(u || '');
    return _open.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    if (/\/cart\/add/.test(this._jtrUrl)) {
      this.addEventListener('load', function () {
        try { fireAddToCart(JSON.parse(this.responseText)); } catch (e) {}
      });
    }
    return _send.apply(this, arguments);
  };

  /* ---- view_item on product pages ---- */
  waitGtag(function () {
    var meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta;
    if (!meta || !meta.product) return;
    var p = meta.product;
    var selectedId = meta.selectedVariantId || (p.variants && p.variants[0] && p.variants[0].id);
    var variant = (p.variants || []).find(function (v) { return v.id == selectedId; }) || (p.variants && p.variants[0]) || {};
    window.gtag('event', 'view_item', {
      currency: currency(),
      value:    (variant.price || 0) / 100,
      items: [{
        item_id:      String(p.id || ''),
        item_name:    p.title || '',
        item_variant: variant.title || '',
        price:        (variant.price || 0) / 100,
        quantity:     1
      }]
    });
  });

})();
